import { Card } from "../common/Card";
import SubscriptionReportData from "../../common/reportDashBShimmer/SubscriptionReportData";
import SubscriptionReportCard from "../reportSummary/SubscriptionReportCard";

export function SubscriptionPlanDetailsSection({
  loading,
  subscriptionData,
}) {
  return (
    <Card className="p-6 bg-white rounded-lg shadow-sm border border-gray-100">
      <span className="mb-4 text-[#1A1A1A]">Subscription Plans Overview</span>
      {loading ? (
        <SubscriptionReportData />
      ) : Object.keys(subscriptionData?.mrrBySubscriptionPlan || {}).length > 0 ? (
        <SubscriptionReportCard subscriptionReportsData={subscriptionData} />
      ) : (
        <div className="flex justify-center items-center h-32 text-gray-400">
          No subscription data available
        </div>
      )}
    </Card>
  );
}
